const customListingCurrencies = {
    MATIC: {
        contract: '0x0000000000000000000000000000000000000000',
        symbol: 'MATIC',
        decimals: 18,
        coinGeckoId: 'matic-network',
    },
    WETH: {
        contract: '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619',
        symbol: 'WETH',
        decimals: 18,
        coinGeckoId: 'weth',
    },
    RCAX: {
        contract: '0x875f123220024368968d9f1aB1f3F9C2f3fd190d',
        symbol: 'RCAX',
        decimals: 18
    },
    CONE: {
        contract: '0xbA777aE3a3C91fCD83EF85bfe65410592Bdd0f7c',
        symbol: 'CONE',
        decimals: 18,
        coinGeckoId: 'bitcone',
    },
    BONE: {
        contract: '0xF297C728cE19E9f61f76c4cF958c32e03E024c4B',
        symbol: 'BONE',
        decimals: 18,
    },
    POOP: {
        contract: '0xc6268A296c810024aa3AA2F5Cc2c255bF995AA44',
        symbol: 'POOP',
        decimals: 18,
    },
    PLUNGER: {
        contract: '0x43ff18fa32e10873fd9519261004a85aE2c7a65d',
        symbol: 'PLUNGER',
        decimals: 18,
    },
    TACO: {
        contract: '0x7eA837454E3c425E01A8432234140755Fc2aDD1c',
        symbol: 'TACO',
        decimals: 18,
    }
}

function getCurrencies() {
    return Object.values(customListingCurrencies)
}

function getTokenAddressFromSymbol(symbol) {
    symbol = symbol.toUpperCase()

    if (customListingCurrencies[symbol]) {
        return customListingCurrencies[symbol].contract
    }

    return null
}

module.exports = {
    customListingCurrencies,
    getCurrencies,
    getTokenAddressFromSymbol,
}
